
import { connect } from "react-redux";
import { Hyperverge } from "./hyperverge";
import {dataToDynamo, dataToStore} from "../../onboarding/actions";

const mapDispatchToProps = dispatch => {
  return {
    dataToDynamo: (data, index, done, disable_load) => dispatch(dataToDynamo(data, index, done, disable_load)),
    dataToStore: (data, index, username) => dispatch(dataToStore(data, index, username)),
  }
}

const mapStateToProps = state => {
  return {
    token: state.user && state.user.token,
    onboarding_token: state.user && state.user.onboarding_token,
    app: state.app,
    user: state.user,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Hyperverge);
